/* eslint-disable  */
import React, { useMemo, useState, useEffect } from 'react';
import {
    Typography, Grid, Select, MenuItem, FormControl, InputLabel, IconButton, Tooltip, Dialog
} from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import {
    useDeleteEval, useFetchEvalDates, useFetchEvals, useSendEvalReminders
} from '~/evals';
import Swal from '#/swal';
import History from '#/history';
import { Delete, Visibility } from '@material-ui/icons';
import GenerateEvalsForm from './GenerateEvalsForm';
import { getState } from '../../store';
import {orderBy} from 'lodash';

const EmployeeEvaluations = () => {

    const { role } = getState().auth;
    const [date, setDate] = useState(null);
    const [openDialog, setOpenDialog] = useState(false);
    const { refetch: sendEvalReminder } = useSendEvalReminders({
        enabled: false,
        refetchOnWindowFocus: false
    });
    const { mutate: deleteEval } = useDeleteEval();
    const { data: dates } = useFetchEvalDates();

    let dateOptions = orderBy(dates?.map( (o) => {
        return {quarter: parseInt(o.split("-")[0].split("Q")[1]), year: parseInt(o.split("-")[1])  }
    }),['year', 'quarter'], ['desc','desc'] )
    .map(({quarter, year}) => `Q${quarter} - ${year}`);

    const { data: evals } = useFetchEvals(date, { enabled: !!date });

    const isAdmin = role === 'admin';

    useEffect(() => {
        if (dates) {
            setDate(dates[dates.length - 1]);
            setDate(dateOptions[0]);
        }
    }, [dates]);

    const columns = useMemo(() => [
        {
            field: 'employee.name',
            renderHeader: () => <strong>Name</strong>,
            valueGetter: ({ row }) => row.employee.name,
            flex: 1
        },
        {
            field: 'employee.department_name',
            renderHeader: () => <strong>Department Name</strong>,
            valueGetter: ({ row }) => {
                if (row.employee.departments.length) {
                    return row.employee.departments[0].name;
                }

                return;
            },
            flex: 1
        },
        {
            field: 'score_average',
            renderHeader: () => <strong>Score Average</strong>,
            valueGetter: ({ row }) => row.score_average,
            flex: .8
        },
        {
            field: 'completed',
            renderHeader: () => <strong>Completed</strong>,
            valueGetter: ({ row }) => row.completed,
            type: 'boolean',
            flex: .8
        },
        {
            field: 'id',
            align: 'right',
            headerAlign: 'right',
            renderHeader: () => <strong>Actions</strong>,
            renderCell: ({ row }) => (
                <div>
                    <Tooltip title='View Evaluation'>
                        <IconButton onClick={() => History.push(`/employees/${row.employee.id}/evals/${row.id}`)}>
                            <Visibility />
                        </IconButton>
                    </Tooltip>
                    {isAdmin && (
                        <Tooltip title='Delete'>
                            <IconButton onClick={() => handleDelete(row.id)}>
                                <Delete />
                            </IconButton>
                        </Tooltip>
                    )}
                </div>

            ),
            flex: 1
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ], []);


    const handleDelete = id => {

        const alertOpts = {
            title: 'Are you sure?',
            showCancelButton: true
        };

        Swal.fire(alertOpts).then(({ value }) => {

            if (value) {
                deleteEval(id);
            }
        });
    };

    const sendEvalReminderEmails = () => {

        Swal.fire({
            title: 'Are you sure?',
            text: 'This will send an email to all department heads informing them that they have incomplete Evals for the current session.',
            showCancelButton: true
        })
            .then(({ value }) => {

                if (value) {

                    sendEvalReminder();

                    Swal.fire({
                        title: 'Success',
                        icon: 'success'
                    });
                }
            });

    };


    return (
        <div>

            <Grid container justifyContent='space-between' style={{ marginBottom: '5px' }}>

                <Grid item xs={9}>
                    <Typography variant='h4' display='inline'>
                        { date && `Employee Evaluations for ${date}`}
                    </Typography>
                </Grid>

                <Grid container item xs={3} justifyContent='flex-end' spacing={2}>

                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel >Eval Session</InputLabel>
                            <Select onChange={e => setDate(e.target.value)}>
                                {(dateOptions || []).map(d => (
                                    <MenuItem key={d} value={d}>{d}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {isAdmin && (
                        <Grid item xs={6}>
                            <FormControl fullWidth>
                                <InputLabel>Global Actions</InputLabel>
                                <Select>
                                    <MenuItem onClick={() => setOpenDialog(true)}>Generate Evals</MenuItem>
                                    <MenuItem onClick={sendEvalReminderEmails}>Send Eval Reminders</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                </Grid>


            </Grid>

            <DataGrid
                columns={columns}
                rows={evals || []}
                autoHeight
            />

            <Dialog fullWidth maxWidth='sm' open={openDialog} onClose={() => setOpenDialog(false)}>
                <GenerateEvalsForm isOpen={openDialog} onClose={() => setOpenDialog(false)}/>
            </Dialog>

        </div>
    );


    // return (
    //     <div style={styles.root}>

    //         <div style={styles.header}>
    //             <div>
    //                 <Header
    //                     as='h2'
    //                     content={`Employee Evaluations for ${date}`}
    //                     color='grey'
    //                 />
    //             </div>

    //             <div>
    //                 <Dropdown text='Eval Session'>
    //                     <Dropdown.Menu>
    //                         {(dates || []).map(date => (
    //                             <Dropdown.Item
    //                                 key={date}
    //                                 content={date}
    //                                 onClick={() => {
    //                                     dispatch({
    //                                         type: 'SET_DATE',
    //                                         payload: date
    //                                     });
    //                                 }}
    //                             />
    //                         ))}
    //                     </Dropdown.Menu>

    //                 </Dropdown>

    //                 <Dropdown text='Global Actions' style={{ marginLeft: '20px' }}>
    //                     <Dropdown.Menu>
    //                         <Dropdown.Item>
    //                             <GenerateEvalsButton dropDownItem={true} />
    //                         </Dropdown.Item>
    //                         <Dropdown.Item>
    //                             <DownloadXLSX
    //                                 dropDownItem={true}
    //                                 meta={{
    //                                     title: date,
    //                                     subject: 'Employee Evaluations'
    //                                 }}
    //                                 headers={[
    //                                     ['employee.name', 'Employee Name'],
    //                                     ['employee.departments[0].name', 'Department Name'],
    //                                     ['employee.title.name', 'Job Title'],
    //                                     ['employee.hire_date', 'Hire Date'],
    //                                     ['score_average', 'Score Average'],
    //                                     ['completed', 'Evaluation Completed']
    //                                 ]}
    //                                 data={data}
    //                             />
    //                         </Dropdown.Item>
    //                         <Dropdown.Item children='Send Eval Reminder Email' onClick={sendEvalReminderEmails}/>
    //                     </Dropdown.Menu>
    //                 </Dropdown>
    //             </div>
    //         </div>

    //         <Table compact sortable singleLine>
    //             <Table.Header>

    //                 <Table.Row>
    //                     <SortableHeader content='Name' sortField='employee.name' />
    //                     <SortableHeader content='Job Title' sortField='employee.title.name' />
    //                     <SortableHeader content='Departments' sortField='employee.departments[0].name' collapsing={true} />
    //                     <SortableHeader content='Hire Date' sortField='employee.hire_date' />
    //                     <SortableHeader content='Score Average' sortField='score_average' collapsing={true}/>
    //                     <SortableHeader content='Completed' sortField='completed'/>
    //                     <Table.HeaderCell collapsing textAlign='center' content='Actions'/>
    //                 </Table.Row>
    //             </Table.Header>
    //             <Table.Body>
    //                 {(data || []).map(evaluation => (
    //                     <Table.Row key={evaluation.id}>
    //                         <Table.Cell content={evaluation.employee.name} />
    //                         <Table.Cell content={evaluation.employee.title.name} />
    //                         <Table.Cell>
    //                             {evaluation.employee.departments.map(({ name }) => <div>{name}</div>)}
    //                         </Table.Cell>
    //                         <Table.Cell content={Dayjs(evaluation.employee.hire_date).format('YYYY-MM-DD')} />
    //                         <Table.Cell content={evaluation.score_average}/>
    //                         <Table.Cell content={evaluation.completed ? 'Yes' : 'No'}/>
    //                         <Table.Cell>
    //                             <Button
    //                                 compact
    //                                 size='small'
    //                                 content='View'
    //                                 onClick={() => {
    //                                     History.push(`/employees/${evaluation.employee.id}/evals/${evaluation.id}`);
    //                                 }}
    //                             />
    //                             <Button
    //                                 negative
    //                                 compact
    //                                 size='small'
    //                                 content='Delete'
    //                                 onClick={() => {
    //                                     handleDelete(evaluation.id);
    //                                 }}
    //                             />
    //                         </Table.Cell>
    //                     </Table.Row>
    //                 ))}
    //             </Table.Body>
    //         </Table>
    //     </div>
    // );
};


export default EmployeeEvaluations;
